/**
 * @file: serviceSubjectItemKeyExtractor.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { ServiceSubjectType } from '@euler/model/enum';
import { ServiceSubjectItem } from '../types';

export const serviceSubjectItemKeyExtractor = (item: ServiceSubjectItem) => {
  if (item.key) {
    return item.key;
  }
  switch (item.type) {
    case ServiceSubjectType.Inspection: {
      return `inspection-template:${item.template.cid}`;
    }
    case ServiceSubjectType.Construction: {
      return item.pendingIssue
        ? `pending-issue:${item.pendingIssue.issue.issueId}`
        : `workitem:${item.title}`;
    }
    case ServiceSubjectType.Fault: {
      return `fault:${item.subject.id}`;
    }
    case ServiceSubjectType.Other: {
      return `other:${item.title}`;
    }
  }
};
